import { FeatureFlagOverrides } from './FeatureFlagOverrides';
export function initializeFeatureFlagOverrides() {
    if (typeof globalThis !== 'undefined') {
        globalThis.FEATURE_FLAG_OVERRIDES =
            FeatureFlagOverrides;
    }
}
